/**
 * Quanto de um lote já saiu — vendido mais reservado.
 *
 * É o piso da quantidade: a API recusa reduzir abaixo disso com
 * `400 "Quantity cannot be less than the N already sold or reserved on this batch"`,
 * e sem travar no formulário o produtor só descobre depois de tentar salvar.
 *
 * Deve ser calculado com o lote **como veio do servidor**, antes de qualquer
 * digitação: `quantity` muda enquanto o produtor edita e a subtração deixaria de
 * valer.
 *
 * `quantity_sold` e `quantity_reserved` existem no payload do painel de vendas,
 * mas não em `/events/detail/{slug}`, que alimenta este formulário — por isso a
 * subtração como caminho principal. Ela dá o mesmo número, já que
 * `quantity_available = quantity - vendido - reservado`.
 */
export function committedQuantity(batch) {
    if (batch?.quantity_sold !== undefined) {
        return (Number(batch.quantity_sold) || 0) + (Number(batch.quantity_reserved) || 0);
    }

    // Lote novo não tem histórico: sem `quantity_available` não há piso.
    if (batch?.quantity_available === undefined) return 0;

    return Math.max((Number(batch.quantity) || 0) - (Number(batch.quantity_available) || 0), 0);
}

/** Mensagem de erro quando a quantidade digitada fica abaixo do que já saiu. */
export function quantityFloorError(committed, value) {
    const floor = Number(committed) || 0;

    if (!floor || Number(value) >= floor) return '';

    return `Já saíram ${floor} unidades deste lote. A quantidade não pode ser menor.`;
}
